export default "__VITE_ASSET__CY6Ibb3e__"